// extracted by mini-css-extract-plugin
module.exports = {"banner":"Agenda_banner__2zGPC","btn":"Agenda_btn__EFS8w","itemsOnImg":"Agenda_itemsOnImg__30gs0","button":"Agenda_button__22gwK"};